<template>
  <VTextTooltiped :tooltipText="_formatDate(true)" :text="_formatDate()">
  </VTextTooltiped>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

import VTextTooltiped from "@/components/VTextTooltiped";
import { formatMomentDT } from "@/utils/util";

export default Vue.component("VDateTooltiped", {
  props: {
    date: VueTypes.any.isRequired
  },

  components: {
    VTextTooltiped
  },

  methods: {
    _formatDate(tooltip = false) {
      const formatString = tooltip ? "h:mm A z" : "MMM D, YYYY z";
      const dateIsMoment = this.date instanceof moment;
      let _date = this.date;

      // Add manually GMT postfix to normally format with moment for UTC timezone
      if (
        _date &&
        !dateIsMoment &&
        this.date.includes("Z") &&
        this.date.includes("GMT")
      ) {
        _date = _date.split("GMT")[0].trim();
      }

      let date = dateIsMoment ? _date : moment(_date);

      return formatMomentDT(date, formatString);
    }
  }
});
</script>

<style lang="scss" scoped></style>
